( function( $ ) {
    'use strict';

    var $accordionTrigger;
    var $accordionBody;

    var activeClassName = 'is-active';

    function registerClickHandler() {
	    $accordionTrigger.on( 'click', function( event ) {
		    $( this ).toggleClass( activeClassName );
		    event.preventDefault();

		    $( this ).next( $accordionBody ).slideToggle( 400, function() {
			    $( this ).toggleClass( activeClassName );
		    } );
	    } );
    }

    $( function() {
	    $accordionTrigger = $( '.js-accordion-trigger' );
	    $accordionBody = $( '.js-accordion-body' );

	    if ( $accordionTrigger.length ) {
		    registerClickHandler();
	    }
    } );
} )( jQuery );
